// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"42089f98","80":"969a8057","108":"e7b4b808","208":"7d6e8f93","256":"3e75d260","264":"ead82fd3","316":"da932568","320":"ac978a1f","340":"e4a22cf2","528":"82d130b9","544":"d28988f6","560":"c5ad2c64","648":"5f20f307","856":"91820efa","888":"97b5e123","988":"303a8478"}[chunkId] + ".chunk.js";
};